import React from "react"
import { withDummyWrapper } from "@components/ui-builder/index"

export const AdminFeedSubscribe = withDummyWrapper(
  React.lazy(() => import(/*webpackChunkName: "ui-builder"*/ "./manager"))
)

export const TeaserEdit = withDummyWrapper(
  React.lazy(() => import(/*webpackChunkName: "ui-builder"*/ "./teaser-edit"))
)

export const TeaserCollection = withDummyWrapper(
  React.lazy(() =>
    import(/*webpackChunkName: "ui-builder"*/ "./dnd").then(c => ({
      default: c.TeaserCollection,
    }))
  )
)

export const TeaserDragSource = withDummyWrapper(
  React.lazy(() =>
    import(/*webpackChunkName: "ui-builder"*/ "./dnd").then(c => ({
      default: c.TeaserDragSource,
    }))
  )
)

export const GalleryCollection = withDummyWrapper(
  React.lazy(() =>
    import(/*webpackChunkName: "ui-builder"*/ "./dnd").then(c => ({
      default: c.GalleryCollection,
    }))
  )
)

export const GalleryDragSource = withDummyWrapper(
  React.lazy(() =>
    import(/*webpackChunkName: "ui-builder"*/ "./dnd").then(c => ({
      default: c.GalleryDragSource,
    }))
  )
)

export const Library = withDummyWrapper(
  React.lazy(() => import(/*webpackChunkName: "ui-builder"*/ "./library"))
)

export const AdminFeedProvider = withDummyWrapper(
  React.lazy(() => import(/*webpackChunkName: "ui-builder"*/ "./provider"))
)
